(function () {
    "use strict";

    angular
        .module("app")
        .directive("strategicBusinessUnitSearchHelp", ["SearchFactory", strategicBusinessUnitSearchHelp]);

    function strategicBusinessUnitSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.strategicBusinessUnitKey = "";
                        scope.strategicBusinessUnitName = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.strategicBusinessUnitName === scope.displayValue)) {
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.strategicBusinessUnitSearch(function (strategicBusinessUnit) {
                        scope.strategicBusinessUnitKey = strategicBusinessUnit ? strategicBusinessUnit.CharacteristicValue : "";
                        scope.strategicBusinessUnitName = strategicBusinessUnit ? strategicBusinessUnit.CharacteristicDesc : "";
                        scope.displayValue = scope.strategicBusinessUnitName;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, ["", scope.displayValue]);
                };

                scope.displayValue = scope.strategicBusinessUnitName;
                scope.prevDisplayValue = scope.displayValue;


                scope.$watch("strategicBusinessUnitName", function (newValue) {
                    scope.displayValue = newValue;
                });
            },
            scope: { strategicBusinessUnitKey: "=", strategicBusinessUnitName: "=", readOnly: "=", required: "=", controlName: "@", needToValidate: "=", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

